import { render, staticRenderFns } from "./Error-5.vue?vue&type=template&id=8725ebd6"
import script from "./Error-5.vue?vue&type=script&lang=js"
export * from "./Error-5.vue?vue&type=script&lang=js"
import style0 from "./Error-5.vue?vue&type=style&index=0&id=8725ebd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports